import moment from 'moment'

export let getMonth = (month) => {
	switch(month) {
			case 0:
					return 'Jan';
					break;
			case 1:
					return 'Feb';
					break;
			case 2:
					return 'Mar';
					break;
			case 3:
					return 'Apr';
					break;
			case 4:
					return 'May';
					break;
			case 5:
					return 'Jun';
					break;
			case 6:
					return 'Jul';
					break;
			case 7:
					return 'Aug';
					break;
			case 8:
					return 'Sep';
					break;
			case 9:
					return 'Oct';
					break;
			case 10:
					return 'Nov';
					break;
			case 11:
					return 'Dec';
					break;
	}
}

export let getTimezoneDate = (date) => {
	if (typeof(date) == "object") return date
	date = new Date(moment(date).format('YYYY-MM-DD'))
	let newDate = new Date(date.valueOf()+date.getTimezoneOffset()*60000)
	return newDate
}



// WEBPACK FOOTER //
// ./src/utils/date.js